import React, { useEffect, useState } from "react";
import MovieCard from "../MovieCard";
import "./style.css";
import FuzzyText from "../Bits/FuzzyText";

const TopMovies = ({ setWatchList, watchList }) => {
  const [genres, setGenres] = useState([]);
  const [filterCtgId, setFilterCtgId] = useState(null);
  const [topMovies, setTopMovies] = useState([]);
  const [loading, setLoading] = useState(false);

  // Lấy danh sách thể loại
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    setLoading(true);
    fetch(`${baseUrl}/genres`)
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then(setGenres)
      .catch(() => setGenres([]))
      .finally(() => setLoading(false));
  }, []);

  // Lấy phim theo filterCtgId
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    setLoading(true);
    const url =
      filterCtgId === null
        ? `${baseUrl}/movies?page=0&size=10&sort=title,asc`
        : `${baseUrl}/movies/genre?genreId=${filterCtgId}`;

    fetch(url)
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => setTopMovies(data.content || []))
      .catch(() => setTopMovies([]))
      .finally(() => setLoading(false));
  }, [filterCtgId]);

  return (
    <section className="new-sec top-rated-sec" id="movies">
      <div className="container">
        <div className="section-title">
          <h5 className="sub-title">RẠP BAGALAXY</h5>
          <h2 className="title">Các thể loại phim</h2>
        </div>

        <div className="categories-btns">
          <button
            className={`btn category-btn ${filterCtgId === null ? "active" : ""
              }`}
            onClick={() => setFilterCtgId(null)}
          >
            All
          </button>

          {genres.map(({ id, name }) => (
            <button
              key={id}
              className={`btn category-btn ${filterCtgId === id ? "active" : ""
                }`}
              onClick={() => setFilterCtgId(id)}
            >
              {name}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
          </div>
        ) : topMovies.length > 0 ? (
          <div className="row movies-grid">
            {topMovies.map((movie) => (
              <MovieCard
                key={movie.id}
                movie={movie}
                setWatchList={setWatchList}
                watchList={watchList}
              />
            ))}
          </div>
        ) : (
          <FuzzyText
            baseIntensity={0.2}
          >
            No movies found
          </FuzzyText>
        )}
      </div>
    </section>
  );
};

export default TopMovies;
